import React from 'react';
import getContainerSizeClass from "@root/helpers/get-container-size-class";
import RichTextNew from "components/rich-text-new";

const IndexedListBlock = ({ data }) => {
    const classes = getContainerSizeClass(data?.moduleSettings);
    const indexStyle = data?.indexStyle || "default";
    const items = data?.items || [];

    const getStyleClass = () => {
        const stylesList = {
            default: "indexed-list-block--default",
            "yellow-rounded": "indexed-list-block--yellow-rounded",
        };
        return stylesList[indexStyle] || stylesList.default;
    };

    return (
        <div className={`indexed-list-block ${getStyleClass()}`}>
            <div className={`indexed-list-block__container ${classes.join(" ")}`}>
                <div className="indexed-list-block__items">
                    {items.map((item, index) => {
                        if (!item || !item._type) return null;
                        return (
                            <div key={item._key || index} className="indexed-list-block__item">
                                <div className="indexed-list-block__item-index">
                                    <span className="indexed-list-block__item-number">{index + 1}</span>
                                </div>
                                <div className="indexed-list-block__item-content">
                                    <RichTextNew data={item} value={item?.data} />
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default IndexedListBlock;

